export default "__VITE_ASSET__CMfJW6ev__"